<template>
  <div class="flex items-center gap-[0.05rem]">
    <button
      v-for="star in maxRating"
      :key="star"
      type="button"
      :class="[
        sizeClasses[size],
        'transition-colors duration-200',
        { 'cursor-pointer': !readonly },
        { 'cursor-default': readonly }
      ]"
      @click="handleClick(star)"
      @mouseenter="handleMouseEnter(star)"
      @mouseleave="handleMouseLeave"
    >
      <UIcon
        name="i-ph-star-fill"
        :class="[
          'w-full h-full',
          (star <= (hoverRating || displayRating)) ? 'text-primary' : 'text-secondary/40',
          readonly ? '' : 'hover:text-primary'
        ]"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue?: number
  rating?: number
  maxRating?: number
  size?: 'sm' | 'md' | 'lg'
  readonly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  rating: undefined,
  maxRating: 5,
  size: 'lg',
  readonly: false
})

const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()

const displayRating = computed(() => props.modelValue ?? props.rating ?? 0)
const hoverRating = ref(0)

const sizeClasses = {
  sm: 'w-5 h-5',
  md: 'w-6 h-6',
  lg: 'w-7 h-7'
}

const handleClick = (value: number) => {
  if (props.readonly) return
  emit('update:modelValue', value)
}

const handleMouseEnter = (value: number) => {
  if (props.readonly) return
  hoverRating.value = value
}

const handleMouseLeave = () => {
  if (props.readonly) return
  hoverRating.value = 0
}
</script>
